import { render, staticRenderFns } from "./DefaultDataFormEdit.vue?vue&type=template&id=1517c97b&"
import script from "./DefaultDataFormEdit.vue?vue&type=script&lang=js&"
export * from "./DefaultDataFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports